class ParallaxMasonry {
    constructor(selector) {
        this.container = document.querySelector(selector);

        if (!this.container) {
            console.warn(`[ParallaxMasonry] Container ${selector} not found.`);
            return;
        }

        this.rows = gsap.utils.toArray(this.container.querySelectorAll('.parallax-row'));
        this.optimizeFirstImage();
        this.init();
    }

    optimizeFirstImage() {
        // Ensure the first image in the DOM loads immediately for LCP optimization
        const firstImage = this.container.querySelector('img');
        if (firstImage) {
            firstImage.setAttribute('loading', 'eager');
            firstImage.setAttribute('decoding', 'sync');
        }
    }

    init() {
        gsap.registerPlugin(ScrollTrigger);

        this.rows.forEach(row => {
            const image = row.querySelector('.image-column img');

            if (!image) return;
            gsap.fromTo(image,
                { yPercent: -20 },
                {
                    yPercent: 20,
                    ease: "power1.inOut",
                    scrollTrigger: {
                        trigger: row,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true
                    }
                }
            );
        });

        window.addEventListener('load', () => {
            ScrollTrigger.refresh();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ParallaxMasonry('.masonry-parallax-section');
});